export const DIGITAL_MEMBER_CARD_PAGES = {
    DISPLAY_COMPANY_CARD: "DISPLAY_COMPANY_CARD",
    CUSTOMISE_EMPLOYEE_CARD: "CUSTOMISE_EMPLOYEE_CARD",
    CUSTOMISE_CLIENT_CARD: "CUSTOMISE_CLIENT_CARD"
};